var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn--more",class:[_vm.$attrs['class']],attrs:{"id":_vm.$attrs['id']}},[_c('icon',{attrs:{"icon":"fill-more"}}),_vm._v(" "),_c('div',{staticClass:"btn--more__content"},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b285dcd4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lib/buttons/ButtonMore.vue
// module id = pnuS
// module chunks = 0